import { render } from "./Staking.vue?vue&type=template&id=52308b1a&scoped=true"
import script from "./Staking.vue?vue&type=script&lang=js"
export * from "./Staking.vue?vue&type=script&lang=js"

import "./Staking.vue?vue&type=style&index=0&id=52308b1a&scoped=true&lang=css"

import exportComponent from "../../../node_modules/.pnpm/vue-loader@17.4.2_@vue+comp_8601aa9edf40feba5c1f16c508af6bdf/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-52308b1a"]])

export default __exports__